import Model from 'flarum/common/Model';
export default class PostTranslation extends Model {
  postId() {
    return Model.attribute('postId').call(this);
  }
  language() {
    return Model.attribute('language').call(this);
  }
  contentHtml() {
    return Model.attribute('contentHtml').call(this);
  }
  provider() {
    return Model.attribute('provider').call(this);
  }
  sourceLanguage() {
    return Model.attribute('sourceLanguage').call(this);
  }
  updatedAt() {
    return Model.attribute('updatedAt', Model.transformDate).call(this);
  }
  isStale() {
    return Model.attribute('isStale').call(this);
  }
  isEdited() {
    return Model.attribute('isEdited').call(this);
  }
}
flarum.reg.add('fof-translate', 'common/models/PostTranslation', PostTranslation);